import {Vue} from "ui.vue";
import "citrus.plugins.form.request";

export let FormMixin = {
	data: function () {
		return {
			loading: false,
			error: false,
			fileError: false,
			success: false,
			message: '',
		}
	},
	computed: {
		allFieldsFilled() {
			return this.fieldsFilled();
		},
	},
	methods: {
		isFileError(data) {
			this.fileError = data.error;
		},
		async isValidate(component, isValid = true) {
			let val = null, self = this,
				ref = 'field', refGroup = 'group';

			if (component) {
				self = component;
			}

			if (self.$refs.hasOwnProperty(ref)) {
				for (let field of self.$refs[ref]) {
					val = await field.checkValid();
					if (!val) {
						isValid = false;
					}
				}
			} else if (self.$refs.hasOwnProperty(refGroup)) {
				for (let group of self.$refs[refGroup]) {
					isValid = await this.isValidate(group, isValid);
				}
			}
			return isValid;
		},
		resetValid(component) {
			let self = this, ref = 'field', refGroup = 'group';

			if (component) {
				self = component;
			}

			if (self.$refs.hasOwnProperty(ref)) {
				for (let field of self.$refs[ref]) {
					field.resetValid();
				}
			} else if (self.$refs.hasOwnProperty(refGroup)) {
				for (let group of self.$refs[refGroup]) {
					this.resetValid(group);
				}
			}
		},
		/**
		 * On form submit
		 *
		 * @param {Event} $event
		 */
		async onSubmit($event) {
			if (this.loading) {
				return;
			}

			let isValid = await this.isValidate();

			if (!isValid || this.fileError) {
				return;
			}

			this.resetResult();

			let formData = new FormData();

			formData.append('FORM_ID', this.formId);
			formData.append('SITE_ID', this.siteId);
			formData.append('signedParameters', this.signedParameters);
			formData.append('sessid', BX.bitrix_sessid());

			for (let field of this.formFields) {
				if (field.hasOwnProperty('MULTIPLE') && field.MULTIPLE) {
					for (var i = 0; i < field.VALUE.length; i++) {
						formData.append(field.CODE + '[' + i + ']', field.VALUE[i]);
					}
				} else {
					formData.append(field.CODE, field.VALUE);
				}
			}

			this.$request
				.setOption({
					componentName: this.componentName,
					action: this.action
				})
				.setData(formData)
				.send()
				.then((response) => {
					if (typeof response == 'object' && null !== response) {
						let message = response.hasOwnProperty("message") && response.message
							? response.message
							: this.getDefaultErrorMessage();

						this.onError(message);
					}
					else {
						this.onSuccess({message: response});
					}
				}, (error) => {
					this.resetFields();
					this.onError(error);
				})
			;
		},
		getDefaultErrorMessage() {
			return "Server error";
		},
		resetResult() {
			this.loading = true;
			this.success = false;
			this.error = false;
			this.message = "";
		},
		onSuccess(response) {
			this.success = true;
			this.message = response.hasOwnProperty("message") ? response.message : "Success sended";
			this.error = false;
			this.loading = false;
		},
		onError(message) {
			this.success = false;
			this.error = true;
			this.message = message;
			this.loading = false;
		},
		resetFields() {
			for (let field of this.formFields) {
				if(true === field.IS_HIDDEN)
					continue;

				field.VALUE = '';
			}
		},

		fieldsFilled(fields = this.formFields, status = true) {
			let isFilled = status;

			for (let field of fields) {
				if (field.GROUP_FIELD == true) {
					isFilled = this.fieldsFilled(field.ITEMS, isFilled);
				} else if (!field.VALUE && field.REQUIRED == "Y") {
					return isFilled = false;
				}
			}
			return isFilled;
		}
	}
};

export default {

	/**
	 * Регистрация глобального миксина во всех экземплярах Vue
	 * Использовать через Vue.use
	 *
	 * @param {Vue} Vue
	 * @param {Object} options
	 */
	install(Vue, options = {}) {
		Vue.mixin(FormMixin);
	}
}